export const TOGGLE_EXPAND_MENU_ITEM = 'TOGGLE_EXPAND_MENU_ITEM'

export const CLOSE_MENU = 'CLOSE_MENU'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const TOGGLE_SIDEBAR_FORCE = 'TOGGLE_SIDEBAR_FORCE'

export const HOVER_SIDEBAR = 'HOVER_SIDEBAR'

export const TOGGLE_WITHOUT_ANIMATION = 'TOGGLE_WITHOUT_ANIMATION'

export const SUBSCRIPTION = 'SUBSCRIPTION'

export const LOGIN = 'LOGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT = 'LOGOUT'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js